import actionTypes from './actions/actiontypes';

const {
  REQUEST_USER_LIST,
  RECEIVE_USER_LIST,
  SERVER_ERROR_OCURED,
  REQUEST_USER_LIST_DETAILS,
  RECEIVE_USER_LIST_DETAILS,
  CLEAR_ERRORS
} = actionTypes;

const usersReducer = (state = {
  isFetchingList: false,
  isFetchingListDetails: false,
  users: [],
  list: [],
  hasServerError: false,
  errors: {},
  success: false,
  msg: '',
  domain: {}
}, action) => {
  switch (action.type) {
   
    case REQUEST_USER_LIST:
      return Object.assign({}, state, {
        isFetchingList: true,
        hasServerError: false,
        errors: {},
        success: false,
        msg: ''
      });
    case CLEAR_ERRORS:
        return Object.assign({}, state, {
          hasServerError: false,
          errors: {},
          success: false,
          msg: ''
        });
    case RECEIVE_USER_LIST:
      return Object.assign({}, state, {
        isFetchingList: false,
        users: action.users,
        domain: action.domain
      });
    case REQUEST_USER_LIST_DETAILS:
      return Object.assign({}, state, {
        isFetchingListDetails: true,
        hasServerError: false,
        errors: {}
      });
    case RECEIVE_USER_LIST_DETAILS:
      return Object.assign({}, state, {
        isFetchingListDetails: false,
        list: action.list
      });
    case "USER_SUCCESS":
        return Object.assign({}, state, {
          hasServerError: false,
          msg: action.msg,
          errors: {},
          success: true
        });
    case SERVER_ERROR_OCURED:
      return Object.assign({}, state, {
        hasServerError: true,
        errors: action.errors,
        success: false
      });
    default:
      return state;
  }
};

export default usersReducer;



// WEBPACK FOOTER //
// src/routes/Users/reducer.js